import {
  getWaterfallInvestmentClassificationSummaryTableDataRetrieveLoader,
  getWaterfallInvestmentClassificationTableDataRetrieveLoader,
} from "gen/endpoints/fund-family-sub-event/fund-family-sub-event";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const waterfallHybridRoutes: RouteObject = {
  id: "capitalActivityCapitalActivityEventWaterfallHybrid",
  path: "hybrid/:fundFamilySubEventId/:fundEntityId",
  lazy: async () => {
    const { HybridWaterfallPage } = await import(
      "features/waterfall/hybrid/HybridWaterfallPage"
    );
    return { Component: HybridWaterfallPage };
  },
  children: [
    {
      id: "capitalActivityCapitalActivityEventWaterfallHybridStatus",
      path: "status",
      lazy: async () => {
        const { HybridInvestmentClassificationsPage } = await import(
          "features/waterfall/hybrid/HybridInvestmentClassificationsPage"
        );
        return { Component: HybridInvestmentClassificationsPage };
      },
      handle: {
        title: i18n.t(
          "waterfall:waterfallClassifications.status.investmentStatus",
        ),
      },
      loader: getWaterfallInvestmentClassificationTableDataRetrieveLoader(),
    },
    {
      id: "capitalActivityCapitalActivityEventWaterfallHybridSummary",
      path: "summary",
      handle: {
        title: i18n.t("waterfall:waterfallClassifications.summary.summary"),
      },
      loader:
        getWaterfallInvestmentClassificationSummaryTableDataRetrieveLoader(),
      lazy: async () => {
        const { HybridWaterfallInvestmentClassificationSummaryPage } =
          await import(
            "features/waterfall/hybrid/HybridWaterfallInvestmentClassificationSummaryPage"
          );
        return {
          Component: HybridWaterfallInvestmentClassificationSummaryPage,
        };
      },
    },
    {
      id: "hybridWaterfallInvestmentReview",
      handle: {
        title: i18n.t("waterfall:waterfallClassifications.reviewWaterfall"),
      },
      // we don't use this page, but we need it to make the wizard work
      path: "",
    },
  ],
};
